<template>
    <v-footer id="onkopus-footer">
        <v-row>
            <v-col cols="12" md="12" lg="4" xl="4">
                <span>
                    2025. Department of Medical Bioinformatics, University Medical Center Göttingen (UMG), Germany.
                </span>
            </v-col>
            <v-col cols="12" md="12" lg="6" xl="6">
                <span class="footer-element">
                    <router-link to="/imprint" style="color:#fff;text-decoration:None;">
                        Imprint
                    </router-link>
                </span>
                <span class="footer-element">
                    <router-link to="/data-privacy" style="color:#fff;text-decoration:None;">
                        Data Privacy
                    </router-link>
                </span>
                <span class="footer-element">
                    <router-link to="/disclaimer" style="color:#fff;text-decoration:None;">
                        Disclaimer
                    </router-link>
                </span>
                <span class="footer-element">
                    <router-link to="/license" style="color:#fff;text-decoration:None;">
                        License
                    </router-link>
                </span>
            </v-col>
            <v-col cols="12" md="12" lg="2" xl="2">
                <img style="border:0px solid red;justify-self: end;" id="logo" src="@/assets/umg-logo-colored.svg" width="240px" height="40px" />
            </v-col>
        </v-row>
    </v-footer>
</template>
<script>

export default {
    data() {
        return {
            show_legalnotice_dialog: false,
        }
    }
}

</script>
<style scoped>
#onkopus-footer {
    width: 100%;
    background-color: #505050;
    justify-items: center;
    color: #fff;
}

.footer-element {
    margin:10px;
}

#legalnotice {
    color: #fff;
    text-decoration: underline;
    cursor: pointer;
}

@media (max-width: 900px) {

#onkopus-footer {font-size: var(--font-400);}
#legalnotice {scale: 0.8 0.8 !important;}
#logo {display: none;}

}

</style>
